import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Dropdown, Icon, Input, Loader } from 'semantic-ui-react';
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import axios from 'axios';
import GConf from '../../AssetsM/generalConf';
import { toast } from 'react-toastify';
import { NavLink, useParams } from 'react-router-dom';

function ProjectInfo() {
    let {PID } = useParams()
    const defaultProjects = [
        {T_ID:1, P_Name:'منصة أبيض ', P_Description :'', T_State: '' , P_Year_Income: 2500, P_Start_Date:'10-05-2018', P_Start_Cost:5000, P_Month_Cost: 150 ,  P_State:'Building'},
        {T_ID:2, P_Name:'دروس خصوصية', P_Description :'', T_State: '' , P_Year_Income: 1350, P_Start_Date:'10-09-2025', P_Start_Cost:5000, P_Month_Cost: 50 ,  P_State:'Building'},
        {T_ID:3, P_Name:'منزل للكراء', P_Description :'', T_State: '' , P_Year_Income: 2700, P_Start_Date:'10-09-2025', P_Start_Cost:5000, P_Month_Cost: 10 ,  P_State:'Building'},
        {T_ID:4, P_Name:'vending machine', P_Description :'', T_State: '' , P_Year_Income: 6000 , P_Start_Date:'10-09-2025', P_Start_Cost:5000, P_Month_Cost: 200 ,  P_State:'Building'},
        {T_ID:5, P_Name:'مشروع فلاحي', P_Description :'', T_State: 'Done' , P_Year_Income: 9000 , P_Start_Date:'10-09-2025', P_Start_Cost:5000, P_Month_Cost: 400 ,  P_State:'Building'},
    ]
    let [tachesListe, setTachesListes] = useState([])
    let [plansListe, setPlansListe] = useState([])
     
    const [openD, setOpenD] = useState(false)
    let [activeIndex, setActiveIndex] = useState('add')
    let [totaleMonth, setTotaleMonth] = useState(0)
    let [totalYear, setTotalYears] = useState(0)
    const [genres , setGenres] = useState({})


    useEffect(()=>{
        axios.post(`${GConf.ApiLink}/houssem/project/info`, {
            P_ID : PID, 
        }).then(function (response) {
                console.log(response.data)
                setTachesListes(response.data.taches)
                setPlansListe(response.data.plans)
                let genresedit = []
                response.data.plans.map( (thisData) => genresedit.push(
                    {key: thisData.PK , value: thisData.PL_ID , text: thisData.PL_Title }
                    ))
                setGenres(genresedit)
        }).catch((error) => {
                console.log(error)
        });
        
        // let yrs = 0
        // let mth = 0
        // defaultProjects.map((data) => {
        //     yrs = yrs + (data.P_Year_Income - (12* data.P_Month_Cost));
        //     mth = mth + (data.P_Month_Income - data.P_Month_Cost);
        // })
        // setTotalYears(yrs.toFixed(3))
        // setTotaleMonth(mth.toFixed(3))
    },[])

    const AddCard = () => {
        const [tacheData , setTacheData] = useState({})
        

        const SaveTache = () => {
            
            if (!tacheData.PL_ID) {toast.error("Matricule Invalide !", GConf.TostErrorGonf)}
            else if (!tacheData.PL_ID) {toast.error("Nom Invalide !", GConf.TostErrorGonf)}
            else{
                 
                axios.post(`${GConf.ApiLink}/houssem/project/insert-tache`, {
                    tacheData : tacheData, 
                    P_ID : PID, 
                }).then(function (response) {
                     console.log(response.data)
                }).catch((error) => {
                     console.log(error)
                });
                        
            }
        }

        return(<>
                <div className='row'>
                   <div className='col-6'>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> T_Title :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={tacheData.T_Title}     onChange={(e) => setTacheData({...tacheData, T_Title: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> T_Description :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={tacheData.T_Description}     onChange={(e) => setTacheData({...tacheData, T_Description: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> T_Genre :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={tacheData.T_Genre}     onChange={(e) => setTacheData({...tacheData, T_Genre: e.target.value })}/>
                        </div>
                         <div className='p-1 mb-2'>
                           <h5 className='mb-1'>PL_ID: </h5>
                            <Dropdown className='w-100 shadow-sm rounded mb-3' placeholder='Famille' search fluid selection options={genres} onChange={(e, data) => setTacheData({...tacheData, PL_ID: data.value })} />
                        </div>
                        
                   </div> 
                    <div className='col-6'>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> T_Start_Date :</h5>
                            <Input icon='key' type='date' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={tacheData.T_Start_Date}     onChange={(e) => setTacheData({...tacheData, T_Start_Date: e.target.value })}/>
                        </div>
                         <div className='p-1 mb-2'>
                            <h5 className='mb-1'> T_End_Date :</h5>
                            <Input icon='key' type='date' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={tacheData.T_End_Date}     onChange={(e) => setTacheData({...tacheData, T_End_Date: e.target.value })}/>
                        </div>
                         <div className='p-1 mb-2'>
                            <h5 className='mb-1'> T_Start_Time :</h5>
                            <Input icon='key' type='time' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={tacheData.T_Start_Time}     onChange={(e) => setTacheData({...tacheData, T_Start_Time: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> T_State :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={tacheData.T_State}     onChange={(e) => setTacheData({...tacheData, T_State: e.target.value })}/>
                        </div>

                        <div className='text-end mb-5'>
                            <Button  onClick={() => SaveTache()}   className='text-end rounded-pill bg-system-btn ' positive>  <Icon name='save outline' /> Save    </Button>
                        </div>
                    </div>
                    
                </div>
        </>)
    }

    const CheckThisTache = (TID,State) => {
        axios.post(`${GConf.ApiLink}/houssem/project/update-tache-state`, {
            T_ID : TID, 
            T_State : State == 'Done' ? '' : 'Done' , 
        }).then(function (response) {
                UpdateUiTocheck(TID)
        }).catch((error) => {
                 
        });

          
        
    }

    const UpdateUiTocheck = (TID) => {
        setTachesListes(prevList =>
            prevList.map(item =>
            item.T_ID === TID
                ? { ...item, T_State: item.T_State === 'Done' ? '' : 'Done' }
                : item
            )
        );
        
    }

    const AddPlan = () => {
        const [addPlanData , setAddPlanData] = useState({})

        const SavePlan = () => {
            
            if (!addPlanData.PL_Title) {toast.error("Matricule Invalide !", GConf.TostErrorGonf)}
            else if (!addPlanData.PL_Start_Date) {toast.error("Nom Invalide !", GConf.TostErrorGonf)}
            else{
                 
                axios.post(`${GConf.ApiLink}/houssem/project/insert-plan`, {
                    projectData : addPlanData, 
                    P_ID : PID, 
                }).then(function (response) {
                     console.log(response.data)
                }).catch((error) => {
                     console.log(error)
                });
                        
            }
        }

        return(<>
                <div className='row'>
                   <div className='col-12 col-lg-5'>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> PL_Title :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='PL_Title' className='w-100 border-0 shadow-sm rounded mb-1' value={addPlanData.PL_Title}     onChange={(e) => setAddPlanData({...addPlanData, PL_Title: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> PL_Description :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='PL_Description' className='w-100 border-0 shadow-sm rounded mb-1' value={addPlanData.PL_Description}     onChange={(e) => setAddPlanData({...addPlanData, PL_Description: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> PL_Start_Date :</h5>
                            <Input icon='key' type='date' iconPosition='left'  placeholder='PL_Start_Date' className='w-100 border-0 shadow-sm rounded mb-1' value={addPlanData.PL_Start_Date}     onChange={(e) => setAddPlanData({...addPlanData, PL_Start_Date: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> PL_State :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='PL_State' className='w-100 border-0 shadow-sm rounded mb-1' value={addPlanData.PL_State}     onChange={(e) => setAddPlanData({...addPlanData, PL_State: e.target.value })}/>
                        </div>
                        <div className='text-end mb-5'>
                            <Button fluid  onClick={() => SavePlan()}   className='  rounded-pill bg-system-btn ' positive>  <Icon name='save outline' /> Ajouter     </Button>
                        </div>

                   </div> 
                    
                    <div className='col-12 col-lg-2'>
                        
                   </div>
                   
                </div>
        </>)
    }

    const OpenBottomSheet = (genre) => {
        setActiveIndex(genre)
        setOpenD(!openD)
    }
    const GetAllTacheListe = (props) => {
        
        let selectTaches = tachesListe.filter((data) => data.PL_ID === props.data)
        console.log(tachesListe.filter((data) => data.PL_ID === props.data))
        return(<>
                {
                selectTaches.map((data,index) => <div className='col-12' dir='ltr'>
                    <Checkbox className={`${data.T_State === 'Done' ? 'text-decoration-line-through' :'' }`} label={data.T_Title} checked={data.T_State === 'Done'} onClick={() => CheckThisTache(data.T_ID, data.T_State)} />  
                </div>)
                }
        </>)
    }
    
 
    return ( <>
        <div className='container-fluid mt-4' dir='rtl'>
            <div className='text-center'><h1>  بسم اللله الرحمان الرحيم   </h1></div>
            <br />
             <div className='row'>
                <div className='mb-4'>
                    <Button basic onClick={() => OpenBottomSheet('add')} color='red'> Ajouter tache  </Button>
                    <Button basic onClick={() => OpenBottomSheet('plan')} color='blue'> Ajouter Plan  </Button>
                     
                </div>
                <div className='col-12 col-lg-9'>
                    <div className='row'>
                        {
                            plansListe.map((data,index) => <div className='col-12' dir='ltr'>
                                <h5>{data.PL_Title}</h5>
                                <div className='mb-3'>
                                    <GetAllTacheListe data={data.PL_ID} />
                                </div>
                            </div>)
                         }

                          
                        
                    </div>
                </div>
                <div className='col-12 col-lg-3'>
                    <div className='ps-4'>
                        <h1 className='text-start mb-2'>TOTALE  </h1>
                        
                        <h2 className='text-start mt-0 mb-1 text-primary' dir='ltr'>Month : {totaleMonth} </h2>
                        <h2 className='text-start mt-1 mb-1 text-info ' dir='ltr'>Year : {totalYear}  </h2>
                    </div>
                </div>
             </div>
            <BottomSheet expandOnContentDrag open={openD}  onDismiss={() => setOpenD(!openD)}  >
                    <div className='card-body'>
                        { activeIndex =='add' ?   <AddCard /> : <></> }   
                        { activeIndex == 'plan' ?  <AddPlan /> : <></> }
                    </div>
            </BottomSheet>
        </div>
    </> );
}

export default ProjectInfo;